import { RedirectRequest } from "@azure/msal-browser";

// AzureB2C設定
export const b2cPolicies = {
    names: {
        signUpSignIn: process.env.REACT_APP_SIGNUP_SIGNIN_NAME,
        forgotPassword: process.env.REACT_APP_FORGOTPASSWORD_NAME
    },
    authorities: {
        signUpSignIn: {
            authority: process.env.REACT_APP_SIGNUP_SIGNIN_AUTH,
        },
        forgotPassword: {
            authority: process.env.REACT_APP_FORGOTPASSWORD_AUTH,
        }
    },
    authorityDomain: process.env.REACT_APP_AUTH_DOMAIN
}

// Config object to be passed to Msal on creation
export const msalConfig: any = {
    b2cScopes: [process.env.REACT_APP_B2C_SCOPES],
    auth: {
        clientId: process.env.REACT_APP_CLIENTID, // This is the ONLY mandatory field; everything else is optional.
        authority: b2cPolicies.authorities.signUpSignIn.authority, // Choose sign-up/sign-in user-flow as your default.
        knownAuthorities: [b2cPolicies.authorityDomain], // You must identify your tenant's domain as a known authority.
        redirectUri: process.env.LOGIN_RETURN_URL, // You must register this URI on Azure Portal/App Registration. Defaults to "window.location.href".
      },
      cache: {
        cacheLocation: "localStorage", // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO.
        storeAuthStateInCookie: false, // If you wish to store cache items in cookies as well as browser cache, set this to "true".
    },
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest: RedirectRequest = {
    scopes: ["openid", ...msalConfig.b2cScopes],
};




